<div class="main-container">
  <div class="loading-shade" *ngIf="isLoadingResults">
    <mat-spinner *ngIf="isLoadingResults" color="accent"></mat-spinner>
  </div>
  <div class="header-container">
    <h4>Brand Definitions</h4>
  </div>
  <div class="definitions-container mat-elevation-z8">
    <mat-accordion>
      <mat-expansion-panel
        *ngFor="let brandDefinition of brandDefinitions"
        hideToggle
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5>{{ brandDefinition.brand }}</h5>
          </mat-panel-title>
          <mat-panel-title>
            <p>{{ brandDefinition.sourceSystem == null ? "" : brandDefinition.sourceSystem}}</p>
          </mat-panel-title>
          <mat-panel-description>
            <p title = "{{brandDefinition.definition}}">{{ brandDefinition.definition }}</p>
            <mat-icon color="accent">edit</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline">
          <mat-label>Source System</mat-label>
          <mat-select #sourceSystem
          [value]="brandDefinition.sourceSystem"
            placeholder="Source System"
          >
            <mat-option
              *ngFor="let source of sourceSystems"
              value="{{ source.sourceSystem }}"
            >
              {{ source.sourceSystem }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="custom">
          <mat-label>Brand Definition</mat-label>
          <textarea matInput rows="5" matAutosize="true" #definition>{{
            brandDefinition.definition
          }}</textarea>
        </mat-form-field>
        <button
          mat-icon-button
          color="accent"
          class="save-button"
          (click)="updateDefinition(brandDefinition, definition.value,sourceSystem.value)"
        >
          <mat-spinner
            *ngIf="isUpdating === true"
            color="accent"
            [diameter]="50"
          ></mat-spinner>
          <mat-icon *ngIf="isUpdating === false">save_alt</mat-icon>
        </button>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
